/**
 * FASE 21.2 — Events Mutation Adapter
 */

import { createChurchEvent, createFieldEvent } from "../../api";
import { generateUUID } from "../../uuid";

/**
 * Create a church or field event.
 * Routes to the correct API function based on event_type.
 * @param {Object} payload — validated
 * @param {Object} appScope
 */
export async function createEventMutation(payload, appScope) {
  const now         = Date.now();
  const church_id   = payload.church_id   ?? appScope?.church_id   ?? null;
  const district_id = payload.district_id ?? appScope?.district_id ?? null;

  const writePayload = {
    id:            generateUUID(),
    title:         payload.title,
    date:          payload.date,
    time:          payload.time ?? null,
    event_type:    payload.event_type,
    location_name: payload.location_name ?? null,
    description:   payload.description   ?? null,
    church_id,
    district_id,
    created_by_kevia: true,
  };

  // Route to appropriate API based on context
  const isFieldEvent = !church_id && !!district_id;
  const data = isFieldEvent
    ? await createFieldEvent(writePayload)
    : await createChurchEvent(writePayload);

  return {
    ok:       true,
    entityId: data?.id ?? writePayload.id,
    summary:  `Evento "${writePayload.title}" creado para el ${writePayload.date}.`,
    meta:     { latency: Date.now() - now, auditType: "administrative" },
  };
}
